module.exports = __webpack_public_path__ + "static/img/icon_suc.5eb7401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/icon_suc.png
// module id = ID4K
// module chunks = 5